// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manual-refresh-button-container{height:30px;width:30px;display:flex}.manual-refresh-button-container:hover{cursor:pointer;background:#d3d3d3;border-radius:6px}.refresh-icon{margin:auto;padding-top:4px;padding-left:4px}.edit-icon{margin:auto}", ""]);
// Exports
module.exports = exports;
